module.exports = __webpack_public_path__ + "img/1对1贴心服务@2x.c3cfe3e4.png";